import React from "react";
import PropTypes from "prop-types";
import { Table, Spin } from "antd";
import { startCase } from "lodash-es";
import { useHistory } from "react-router";

const UserRolesTable = (props) => {
  const { isLoading, data } = props;
  const history = useHistory();

  const getUserRolesColumns = () => {
    const renderRoleName = (text, record) => (
      <div className="user-role-name" onClick={() => history.push(`roles/${record.id}/edit`)}>
        {startCase(text)}
      </div>
    );

    return [
      {
        title: "User Role",
        dataIndex: "name",
        key: "name",
        render: renderRoleName,
      },
    ];
  };

  if (isLoading) {
    return (
      <div className="organization-roles spinning">
        <Spin tip="fetching roles..." />
      </div>
    );
  }

  return (
    <div className="organization-roles-table">
      <Table
        dataSource={data}
        columns={getUserRolesColumns()}
        pagination={true}
        size="small"
        scroll={{ x: 800 }}
        rowKey={(record) => record.id}
      />
    </div>
  );
};

UserRolesTable.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  data: PropTypes.array.isRequired,
};

export default UserRolesTable;
